import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewDocumentDetailComponent } from './view-document-detail/view-document-detail.component';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { CoreSidebarModule } from '@core/components';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CoreCommonModule } from '@core/common.module';
import { ContentHeaderModule } from 'app/layout/components/content-header/content-header.module';
import { CoreTouchspinModule } from '@core/components/core-touchspin/core-touchspin.module';
import { ColorPickerModule } from 'ngx-color-picker';
import { EformRecipientFieldsComponent } from 'app/main/signing-pages/eform-recipient-fields/eform-recipient-fields.component';
import { RecipientIdAttachFieldComponent } from 'app/main/signing-pages/recipient-id-attach-field/recipient-id-attach-field.component';
import { SigningSidebarComponent } from 'app/main/signing-pages/signing-sidebar/signing-sidebar.component';
import { SharedModule } from 'app/main/shared/shared/shared.module';
import { MoreComponent } from 'app/main/signing-pages/signing-sidebar/more/more.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TranslocoDirective } from '@jsverse/transloco';


const appRoutes: Routes = [
  {
      path: ':id/:token',
      component: ViewDocumentDetailComponent,
      data: { signingArea: true, page:'signing', is_sender: 1 }
  },
]


@NgModule({
  declarations: [
    ViewDocumentDetailComponent,
    SigningSidebarComponent,
    EformRecipientFieldsComponent,
    RecipientIdAttachFieldComponent,
    MoreComponent
  ],
  imports: [
    CommonModule,
    CoreCommonModule,
    FormsModule,
    ContentHeaderModule,
    NgbModule,
    SharedModule,
    NgSelectModule,
    ColorPickerModule,
    CoreTouchspinModule,
    NgScrollbarModule,
    CoreSidebarModule,
    TranslocoDirective,
    RouterModule.forChild(appRoutes)
  ],
  exports: [
    ViewDocumentDetailComponent,
    SigningSidebarComponent,
    EformRecipientFieldsComponent,
    RecipientIdAttachFieldComponent,
    MoreComponent
  ]
})
export class DocumentDetailModule { }
